<template>
    <div v-loading.fullscreen.lock="spin.loading">
        <div class="bg-sea-light py-4 subtitle flex justify-center px-2">
            <div class="container text-center">
                <p class="font-semibold mb-3 text-xl-scale">Motor Insurance</p>
                <p class="font-normal text-sm-scale mb-3">Embark on every journey with confidence and peace of mind. Our motor vehicle insurance offers more than protection; it's a shield for your adventures. Whether it's a daily commute or a weekend escape, we've got you covered. Affordable rates, personalized plans – because your safety is non-negotiable.</p>
            </div>
        </div>

        <p id="step-form" class="container flex justify-center text-center font-semibold text-lg-scale mt-4">Insurance at your fingertips!</p>
        <p class="font-normal text-center text-sm-scale mb-4">Experience the simplicity of securing your vehicle or motorcycle coverage. A single click for instant peace of mind.</p>
        <div class="container">
            <div class="step-card-motor grid grid-cols-1 p-3 xs:p-10">
                    <div class="grid grid-cols-3 mb-2">
                    <div class="flex justify-center">
                        <div v-if="step >= 0" class="popover">
                            <div class="popover-content">
                                <p class="font-semibold text-white text-md-scale">Step 1</p>
                            </div>
                        </div>
                        <div v-else class="popover popover-waiting">
                            <div class="popover-content">
                                <p class="font-semibold text-secondary text-md-scale">Step 1</p>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-center">
                        <div v-if="step >= 1" class="popover">
                            <div class="popover-content">
                                <p class="font-semibold text-white text-md-scale">Step 2</p>
                            </div>
                        </div>
                        <div v-else class="popover popover-waiting">
                            <div class="popover-content">
                                <p class="font-semibold text-secondary text-md-scale">Step 2</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center">
                        <div v-if="step >= 2" class="popover">
                            <div class="popover-content">
                                <p class="font-semibold text-white text-md-scale">Step 3</p>
                            </div>
                        </div>
                        <div v-else class="popover popover-waiting">
                            <div class="popover-content">
                                <p class="font-semibold text-secondary text-md-scale">Step 3</p>
                            </div>
                        </div>
                    </div>
                </div>
                    <el-steps :active="step" align-center>
                        <el-step>
                            <template slot="icon">
                                <i style="font-size: 20px!important;" class="las la-dot-circle"></i>
                            </template>
                            <template slot="description">
                                <div>
                                    <div class="mt-2">
                                        <img src="/img/Choice.png" width="23" alt="">
                                    </div>
                                    <div>
                                        <span style="color: #4DA499;font-size: calc(12px + 1*((100vw - 320px)/1120))">Options & Information</span>
                                    </div>
                                </div>
                            </template>
                        </el-step>
                        <el-step>
                            <template slot="icon">
                                <i style="font-size: 20px!important;" class="las la-dot-circle"></i>
                            </template>
                            <template slot="description">
                                <div class="mt-2 mb-1">
                                    <img v-if="step ===0" src="/img/Group.png" width="26" alt="">
                                    <img v-if="step >=1" src="/img/CardChecked.png" width="26" alt="">
                                </div>
                                <div>
                                    <!--<span style="font-size: calc(12px + 1*((100vw - 320px)/1120))" v-if="step ===0">Upload {{formData.policy_type?formData.policy_type:'Vehicle'}} Registration </span>
                                    <span style="font-size: calc(12px + 1*((100vw - 320px)/1120));color: #4DA499" v-if="step >=1">Upload {{formData.policy_type?formData.policy_type:'Vehicle'}} Registration </span>-->
                                    <span style="font-size: calc(12px + 1*((100vw - 320px)/1120))" v-if="step ===0">Upload Motor Registration </span>
                                    <span style="font-size: calc(12px + 1*((100vw - 320px)/1120));color: #4DA499" v-if="step >=1">Upload Motor Registration </span>
<!--                                    <span style="font-size: calc(12px + 1*((100vw - 320px)/1120));color: #4DA499">Upload Motor Registration </span>-->
                                </div>
                            </template>
                        </el-step>
                        <el-step>
                            <template slot="icon">
                                <i style="font-size: 20px!important;" class="las la-dot-circle"></i>
                            </template>
                            <template slot="description">
                            <span class="text-xs-scale">
                                 <div class="mt-2">
                                    <img v-if="step<=1" src="/img/Check.png" width="23" alt="">
                                    <img v-if="step===2" src="/img/PaymentChecked.png" width="23" alt="">
                                </div>
                                <div>
                                    <span v-if="step<=1" style="font-size: calc(12px + 1*((100vw - 320px)/1120))">Payment & Info Verification</span>
                                    <span v-if="step===2" style="color: #4DA499;font-size: calc(12px + 1*((100vw - 320px)/1120))">Payment & Info Verification</span>
                                </div>
                            </span>
                            </template>
                        </el-step>
                    </el-steps>
                    <div @click="onClickForm">
                        <el-form  style="z-index: 1" v-loading="spin.next" :disabled="!isAgreeBuyNow" label-position="top" :model="formData" :rules="rulesFormData" ref="formDataForm">
                            <div v-if="step === 1" class="pt-4">
                                <p class="font-semibold w-full mb-3 text-md-scale text-center">Step 2 : Upload Photo of Your {{formData.policy_type}} Registration</p>
                                <UploadRegistrationCard :formData="formData" @change="(time) => {lastUploadTime = time}" :key="lastUploadTime" :motors="motors"/>
                            </div>
                            <div v-else-if="step === 2">
                                <p class="font-semibold text-center my-3 text-md-scale">Step 3 : Payment and Information Verification</p>
                                        <div class=" grid grid-cols-12 xs:grid-cols-12 mt-3">

                                            <div class="col-span-12 xs:col-span-6">
                                                <div v-if="formData.type === 'Individual'">
                                                    <div class=" grid grid-cols-12 xs:grid-cols-12">
                                                        <div class="col-span-12 xs:col-span-12">
                                                            <div class="flex items-center">
                                                                <img width="13" height="15" src="/img/team-rep.png" alt="#">
                                                                <p class="font-semibold text-sm-scale mt-1">Team Representative</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">English Name</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.insured_name}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Khmer Name</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.insured_name_kh}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Gender</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.gender}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">National ID No.</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.id_card}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Phone</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.phone}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Email</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.email}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Address</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.full_address}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Using</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.policy_type}}</p>
                                                        </div>

                                                        <div class="col-span-3 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Type</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-8 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.type}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="formData.type === 'Company'">
                                                    <div class=" grid grid-cols-12 xs:grid-cols-12">
                                                        <div class="col-span-12 xs:col-span-12">
                                                            <div class="flex items-center">
                                                                <img width="13" height="15" src="/img/GroupCompany.png" alt="#">
                                                                <p class="font-semibold ml-2 text-sm-scale">Company Information</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-span-4 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Company Name</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-7 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.insured_name}}</p>
                                                        </div>

                                                        <div class="col-span-4 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Company Phone</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-7 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.phone}}</p>
                                                        </div>

                                                        <div class="col-span-4 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Company Address</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-7 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.full_address}}</p>
                                                        </div>

                                                        <div class="col-span-4 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Company Email</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-7 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.email}}</p>
                                                        </div>

                                                        <div class="col-span-4 xs:col-span-4 mt-3">
                                                            <p class="font-medium text-xs-scale">Using</p>
                                                        </div>
                                                        <div class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div class="col-span-7 xs:col-span-7 mt-3">
                                                            <p class="font-semibold text-xs-scale">{{formData.policy_type}}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-span-12 xs:col-span-6">
                                                    <div class=" grid grid-cols-12 xs:grid-cols-12">
                                                        <div class="col-span-12 xs:col-span-12 mt-3 xs:mt-0">
                                                            <div class="flex items-center">
                                                                <img width="13" height="15" src="/img/plan.png" alt="#">
                                                                <p class="font-semibold ml-2 text-sm-scale">Options Selected</p>
                                                            </div>
                                                        </div>
                                                        <div v-if="formData.type === 'Company'" class="col-span-4 xs:col-span-3 mt-3">
                                                            <p class="font-bold text-xs-scale">Option</p>
                                                        </div>
                                                        <div v-if="formData.type === 'Company'" class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div v-if="formData.type === 'Company'" class="col-span-7 xs:col-span-8 mt-3 ml-1 xs:ml-0">
                                                            <p class="font-bold">{{formData.options}}</p>
                                                        </div>
                                                        <div v-if="formData.type !== 'Company'" class="col-span-3 xs:col-span-3 mt-3">
                                                            <p class="font-bold text-xs-scale">Option</p>
                                                        </div>
                                                        <div v-if="formData.type !== 'Company'" class="col-span-1 xs:col-span-1 mt-3">
                                                            <span>:</span>
                                                        </div>
                                                        <div v-if="formData.type !== 'Company'" class="col-span-8 xs:col-span-8 mt-3 ml-1 xs:ml-0">
                                                            <p class="font-bold">{{formData.options}}</p>
                                                        </div>
                                                        <div v-if="formData.type === 'Company'" class="col-span-4 xs:col-span-4"></div>
                                                        <div v-if="formData.type !== 'Company'" class="col-span-4 xs:col-span-4"></div>
                                                        <div v-if="formData.type ==='Company'" class="col-span-8 xs:col-span-8 mt-2 pl-8 xs:pl-0">
                                                            <div><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                                            <div v-if="formData.options === 2 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>
                                                            <div v-if="formData.options === 2 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>
                                                            <div v-if="formData.options === 3 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident to Driver</span></div>
                                                            <div v-if="formData.options === 3 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>
                                                            <div v-if="formData.optionals.includes('Flood')"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Flood</span></div>
                                                            <div class="flex xs:flex" v-if="formData.optionals.includes('Strikes, Riots and Civil Commotion Clause')"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Strikes, Riots and Civil Commotion Clause</span></div>
                                                        </div>
                                                        <div v-if="formData.type !=='Company'" class="col-span-8 xs:col-span-8 mt-2 xs:pl-0">
                                                            <div><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                                            <div v-if="formData.options === 2 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>
                                                            <div v-if="formData.options === 2 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>
                                                            <div v-if="formData.options === 3 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident to Driver</span></div>
                                                            <div v-if="formData.options === 3 || formData.options === 4"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>
                                                            <div v-if="formData.optionals.includes('Flood')"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Flood</span></div>
                                                            <div v-if="formData.optionals.includes('Strikes, Riots and Civil Commotion Clause')" class="flex xs:flex"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Strikes, Riots and Civil Commotion Clause</span></div>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="col-span-12 xs:col-span-12 my-4">
                                                <div>
                                                    <p class="text-xs-scale">The representation of the {{formData.policy_type}} is underrepresented by<span class="font-semibold text-xs-scale text-navy xs:ml-2 ml-1">{{formData.insured_name}}</span></p>
                                                </div>
                                            </div>
                                            <div class="col-span-12 xs:col-span-12">
                                                <div class="hidden xs:flex">
                                                    <el-table
                                                        height="300"
                                                        :header-cell-style="{color:'#FFF',background : '#4DA499',}"
                                                        :cell-style="{background :'#FAFAFA',marginTop:'5px'}"
                                                        :data="motors"
                                                        class="w-full h-100 mb-1">
                                                        <el-table-column
                                                            show-overflow-tooltip
                                                            label="Brand"
                                                            width="*">
                                                            <template slot-scope="scope">
                                                                <p class="font-semibold text-xs-scale">{{scope.row.brand}}</p>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            show-overflow-tooltip
                                                            label="Plate No"
                                                            min-width="170px"
                                                            width="*">
                                                            <template class="block" slot-scope="scope">
                                                                <div>
                                                                    <p class="font-semibold text-xs-scale">{{scope.row.plate_no}}</p>
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            show-overflow-tooltip
                                                            label="Year"
                                                            min-width="80px"
                                                            width="80px">
                                                            <template class="block" slot-scope="scope">
                                                                <div>
                                                                    <p class="font-semibold text-xs-scale">{{scope.row.year_made}}</p>
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            show-overflow-tooltip
                                                            width="120px"
                                                            min-width="120px"
                                                            align="center"
                                                            label="Cubic Capacity">
                                                            <template slot-scope="scope">
                                                                <p class="font-semibold text-xs-scale">{{scope.row.cylinder_size}}</p>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            v-if="(formData.options === 3 || formData.options === 4) && formData.policy_type_id === 16"
                                                            show-overflow-tooltip
                                                            width="70px"
                                                            min-width="70px"
                                                            align="center"
                                                            label="Seats">
                                                            <template slot-scope="scope">
                                                                <p class="font-semibold text-xs-scale">{{scope.row.seat_no?scope.row.seat_no:''}}</p>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            v-if="formData.options === 2 || formData.options === 4"
                                                            show-overflow-tooltip
                                                            width="110px"
                                                            min-width="110px"
                                                            align="right"
                                                            label="Motor Price">
                                                            <template slot-scope="scope">
                                                                <p class="font-semibold text-xs-scale">{{scope.row.sum_insured?scope.row.sum_insured.toLocaleString('en-US', { style: 'currency', currency: 'USD' }):''}}</p>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            min-width="100px"
                                                            width="140px"
                                                            align="right"
                                                            label="Price">
                                                            <template slot-scope="scope">
                                                                <p class="font-semibold text-xs-scale">{{scope.row.premium? scope.row.premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' }):''}}</p>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>

                                                <div class="flex xs:hidden">
                                                    <el-table
                                                        :header-cell-style="{color:'#FFF',background : '#4DA499',}"
                                                        :cell-style="{background :'#FAFAFA',marginTop:'5px'}"
                                                        :data="motors"
                                                        class="w-full h-70 mb-1">
                                                        <el-table-column
                                                            show-overflow-tooltip
                                                            label="Motor Information"
                                                            min-width="120px"
                                                            width="*">
                                                            <template class="block" slot-scope="scope">
                                                                <div>
                                                                    <p class="font-medium text-xs">{{scope.row.brand}}</p>
                                                                </div>
                                                                <div>
                                                                    <p class="font-medium text-xs">{{scope.row.plate_no}}</p>
                                                                </div>
                                                                <div>
                                                                    <p class="font-medium text-xs">Year:{{scope.row.year_made}}</p>
                                                                </div>
                                                                <div>
                                                                    <p class="font-medium text-xs"><span class="font-medium text-xs">Cubic Capacity:{{scope.row.cylinder_size}}</span></p>
                                                                </div>
                                                                <div v-if="(formData.options === 3 ||formData.options === 4) && formData.policy_type_id === 16">
                                                                    <p class="font-medium text-xs"><span class="font-medium text-xs">Seats:{{scope.row.seat_no}}</span></p>
                                                                </div>
                                                                <div v-if="formData.options === 2 ||formData.options === 4">
                                                                    <p class="font-medium text-xs"><span class="font-medium text-xs">Motor Price:USD{{scope.row.sum_insured}}</span></p>
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                            <!-- <el-table-column
                                                            show-overflow-tooltip
                                                            width="110px"
                                                            align="right"
                                                            min-width="85px"
                                                            label="Motor Price">
                                                            <template slot-scope="scope">
                                                                <span class="font-medium text-xs">{{scope.row.sum_insured?scope.row.sum_insured.toLocaleString('en-US', { style: 'currency', currency: 'USD' }):''}}</span>
                                                            </template>
                                                        </el-table-column>-->
                                                        <el-table-column
                                                            min-width="80px"
                                                            width="140px"
                                                            align="right"
                                                            show-overflow-tooltip
                                                            label="Price">
                                                            <template slot-scope="scope">
                                                                <p class="font-medium text-xs"><span>{{scope.row.premium? scope.row.premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' }):''}}</span></p>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                                <div class="mt-2">
                                                    <el-divider class="my-0 bg-navy mb-2"></el-divider>
                                                </div>
                                            </div>


<!--                                            <div class="col-span-8 text-left">-->
<!--                                                <p class="font-semibold text-md-scale ml-2">Total</p>-->
<!--                                            </div>-->
<!--                                            <div class="col-span-12 text-right">-->
<!--                                                <p v-if="formData.valid_coupon === 1" class="text-md-scale font-semibold mr-2 text-danger" style="text-decoration:line-through solid currentColor 1.5px">{{formData.old_total_premium?formData.old_total_premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : ''}}</p>-->
<!--                                                <p class="text-md-scale font-semibold mr-2">Total {{formData.total_premium?formData.total_premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : ''}}</p>-->
<!--                                            </div>-->

                                            <div class="col-span-9 md:col-span-11 text-right pt-1">
                                                <p v-if="formData.valid_coupon !== 1"  class="text-md-scale font-semibold">Total</p>
                                            </div>
                                            <div class="col-span-3 md:col-span-1 pt-1 text-right">
                                                <p v-if="formData.valid_coupon === 1" class="text-sm-scale text-danger font-medium" style="text-decoration:line-through solid currentColor 1.5px">{{ (formData.old_total_premium).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</p>
                                                <p v-else class="text-md-scale font-semibold">{{ formData.total_premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</p>
                                            </div>
                                            <div v-if="formData.valid_coupon === 1 && (formData.total_premium_f > 0 || formData.total_premium_src > 0)" class="col-span-9 md:col-span-11 text-right pt-0.5 md:pt-1">
                                                <span class="font-semibold text-xs-scale md:text-sm-scale">After disc </span>
                                            </div>
                                            <div v-if="formData.valid_coupon === 1 && (formData.total_premium_f > 0 || formData.total_premium_src > 0)" class="col-span-3 md:col-span-1 pt-1 text-right">
                                                <p class="text-sm-scale font-medium">{{(formData.after_dis).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</p>
                                            </div>

                                            <div v-if="formData.valid_coupon === 1" class="col-span-9 md:col-span-11 text-right pt-0.5 md:pt-1" :class="{'!col-span-10 !md:col-span-11':formData.total_premium_f > 0 && formData.total_premium_src > 0}">
                                                <span v-if="formData.total_premium_f > 0 && formData.total_premium_src > 0" class="font-semibold text-xs-scale md:text-sm-scale"><span class="text-danger">* </span>Flood + Strikes, Riots and Civil Commotion Clause</span>
                                                <span v-else-if="formData.total_premium_f > 0" class="font-semibold text-xs-scale md:text-sm-scale"><span class="text-danger">* </span>Flood</span>
                                                <span v-else-if="formData.total_premium_src > 0" class="font-semibold text-xs-scale md:text-sm-scale"><span class="text-danger">* </span>Strikes, Riots and Civil Commotion Clause</span>
                                                <span v-else class="font-semibold text-xs-scale md:text-sm-scale"></span>
                                            </div>
                                            <div v-if="formData.valid_coupon === 1" class="col-span-3 md:col-span-1 pt-1 text-right" :class="{'!col-span-2 !md:col-span-1':formData.total_premium_f > 0 && formData.total_premium_src > 0}">
                                                <p v-if="formData.total_premium_f > 0 || formData.total_premium_src > 0" class="text-sm-scale font-medium">{{ (formData.total_premium_src + formData.total_premium_f).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</p>
                                            </div>
                                            <div v-if="formData.valid_coupon === 1" class="col-span-9 md:col-span-11 text-right">
                                                <p class="text-md-scale font-semibold">Total</p>
                                            </div>
                                            <div v-if="formData.valid_coupon === 1" class="col-span-3 md:col-span-1 text-right">
                                                <p class="text-md-scale font-semibold">{{formData.total_premium.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</p>
                                            </div>


<!--                                            <div class="col-span-12 text-right">-->
<!--                                                <p class="text-md-scale font-semibold mr-2 text-danger" style="text-decoration:line-through solid currentColor 1.5px">{{(100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</p>-->
<!--                                                <p class="font-semibold mr-2 text-xs-scale">After disc <span class="text-md-scale">{{(20).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</span></p>-->
<!--                                                <p class="font-medium mr-2 text-xs-scale"> <span class="text-md-scale font-semibold">{{(100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</span></p>-->
<!--                                                <p class="text-md-scale font-semibold mr-2 ">Total {{(100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</p>-->
<!--                                            </div>-->
                                            <div class="col-span-12 block xs:flex xs:justify-between py-2">
                                                <div class="pr-1">
                                                    <span class="font-medium text-sm-scale mt-1 text-wrap leading">* Annual fee that effective from <span class="underline font-medium text-sm-scale">{{$moment(formData.period_from).format('DD/MMM/YYYY')}}</span> to  <span class="underline font-medium text-sm-scale">{{$moment(formData.period_to).format('DD/MMM/YYYY')}}</span>.</span>
                                                </div>
                                                <div  v-if="formData.policy_type === 'Private Vehicle'" class="items-center w-64 mb-3 text-left mt-2 xs:mt-0">
                                                    <span class="text-sm-scale font-medium">Coupon code: <span class="text-xs-scale font-normal" :class="{'text-danger': formData.valid_coupon === 2 || formData.valid_coupon === 3,'text-success':formData.valid_coupon === 1}">{{formData.valid_coupon === 1?'Activated':formData.valid_coupon === 2?'Expired code':formData.valid_coupon === 3?'Invalid code':''}}</span></span>
                                                    <el-input :disabled="formData.valid_coupon === 1" class="!rounded-none" v-model="formData.coupon_code" size="small" :maxlength="10"><template slot="append"><el-button class="rounded-l-none rounded-r" size="small" @click="onCheckCouponCode" :loading="spin.activate"><span class="!text-[13px] !font-normal">{{formData.valid_coupon !== 1?'Activate':'Clear'}}</span></el-button></template> </el-input>
                                                </div>
                                            </div>
                                            <!--<div class="col-span-12 xs:col-span-12 xs:text-center">
                                                <div class="grid grid-cols-12 xs:grid-cols-12 mt-3 xs:mt-3">
                                                    <div class="col-span-12 xs:col-span-10 flex xs:flex items-center pl-1 xs:pl-0">
                                                        <div class="flex items-center">
                                                            <img src="/img/Select.png" width="12" height="12">
                                                            <p class="ml-2 font-medium text-sm-scale">I agree to the terms of the contract.</p>
                                                        </div>
                                                        <div class="ml-2 xs:ml-1 mb-1">
                                                            <a class="font-semibold text-sm-scale" v-if="formData.policy_type==='Motocycle'" href="/doc/motor/motorcycle.pdf" download>Download PDF</a>
                                                            <a class="font-semibold text-sm-scale" v-else href="/doc/motor/private-vehicle.pdf" download>Download PDF</a>
                                                        </div>
                                                    </div>
                                                    <div class="col-span-12 xs:col-span-2 flex items-center xs:text-right text-center my-5 xs:mx-2 px-5 xs:pl-0 xs:mt-3">
                                                        <el-button size="small" @click="previous"
                                                                   class="text-primary font-normal text-sm-scale px-5"
                                                                   style="border-color: var(&#45;&#45;primaryColor);">Back</el-button>
                                                        <el-button
                                                            class="bg-navy text-white border-0 py-3 text-sm-scale font-normal w-40"
                                                            @click="onSaveDoc" :loading="spin.payment" size="small">Pay Now
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </div>-->
                                        </div>
                                        <div class="items-center grid grid-cols-1 xs:grid-cols-3">
                                            <div class="col-span-2 xs:col-span-2 text-left flex items-center">
                                                <div class="flex items-center">
                                                    <img class="mr-1" src="/img/Select.png" width="12" height="12">
                                                    <p class="font-medium text-sm-scale">I agree to the terms of the contract.</p>
                                                    <a class="font-semibold text-sm-scale ml-1" v-if="formData.policy_type==='Motocycle'" href="/doc/motor/motorcycle.pdf" download>Download PDF</a>
                                                    <a class="font-semibold text-sm-scale ml-1" v-else href="/doc/motor/private-vehicle.pdf" download>Download PDF</a>
                                                </div>
                                            </div>
                                            <div class="col-span-1 xs:col-span-1">
                                                <div class="flex items-center justify-end pt-2">
                                                    <el-button :disabled="spin.payment" size="small" @click="previous" class="text-primary font-normal text-sm-scale px-5" style="border-color: var(--primaryColor);">Back</el-button>
                                                    <el-button :loading="spin.payment"
                                                        class="w-40 bg-navy text-white border-0 py-3 text-sm-scale font-medium"
                                                        @click="onOpenPaymentMethod" size="small">Pay Now
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                            <!--Step 1-->
                            <div v-else class="pt-4 grid grid-cols-1 xs:grid-cols-2  gap-x-3 xs:gap-x-5">
                                <div class="col-span-4">
                                    <p class="font-semibold col-span-2 w-full mb-3 text-md-scale text-center">Step 1 : Which option is best for you?</p>
                                </div>
                                <div class="col-span-4 xs:col-span-4">
                                    <div class="grid grid-cols-4 xs:grid-cols-4">
                                        <div class="xs:col-span-2 col-span-4 mt-3 xs:mt-5">
                                            <p class="xs:mt-1 font-semibold text-sm-scale"><span class="text-danger">*</span>What type of transportation do you prefer?</p>
                                        </div>
                                        <div class="xs:col-span-2 col-span-4 mt-3 xs:mt-5">
                                            <el-form-item size="small" prop="policy_type">
                                                <el-radio-group v-on:change="onSelectProductType" v-model="formData.policy_type">
                                                    <el-radio class="p-0" label="Private Vehicle"></el-radio>
                                                    <el-radio class="p-0" label="Motocycle"></el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>

                                <div class="hidden xs:block xs:grid xs:grid-cols-4 xs:gap-x-3 col-span-4 xs:col-span-4 xs:my-3">
                                    <div v-for="(opt, index) in Options">
                                        <el-radio-group @change="onSelectScopeOfCoverOption" v-model="formData.options">
                                            <div class="flex items-center">
                                                <el-radio :label="index + 1"><span class="font-medium text-sm-scale">{{ 'option ' + opt.opt }}</span></el-radio>
                                            </div>
                                        </el-radio-group>
                                    </div>
                                    <div class="col-span-4 xs:col-span-4 grid grid-cols-4 gap-x-3">
                                        <div class="col-span-2 xs:col-span-1 pl-3">
                                            <div class="items-center" v-if="formData.options === 1"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                            <div class="items-center" v-if="formData.options !== 1"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Third Party Liability</span></div>
											<!--<div class="items-center" v-if="formData.options !== 1"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>-->
                                        </div>
                                        <div class="col-span-2 xs:col-span-1 pl-3">
											<!--<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>-->
											<!--<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>-->
											<!--<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>-->
											<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Third Party Liability</span></div>
											<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Own Damage</span></div>
											<div v-if="formData.options !== 2"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Theft</span></div>
                                            <div v-if="formData.options === 2"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                            <div v-if="formData.options === 2"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>
                                            <div v-if="formData.options === 2"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>
                                        </div>
                                        <div class="col-span-2 xs:col-span-1 pl-3">
											<!--<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>-->
											<!--<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident To Driver</span></div>-->
											<!--<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle 39.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>-->
											<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Third Party Liability</span></div>
											<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Accident To Driver</span></div>
											<div v-if="formData.options !== 3"><img class="mr-2" src="/img/Rectangle2.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Passenger Liability</span></div>
                                            <div v-if="formData.options === 3"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                            <div v-if="formData.options === 3"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident To Driver</span></div>
                                            <div v-if="formData.options === 3"><img class="mr-2" src="/img/Select.png" width="13" height="13"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>
                                        </div>
                                        <div class="col-span-2 xs:col-span-1 pl-3">
											<!--<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle 39.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>-->
											<!--<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle 39.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>-->
											<!--<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle 39.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>-->
											<!--<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle 39.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident To Driver</span></div>-->
											<!--<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle 39.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>-->
											<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle2.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Third Party Liability</span></div>
											<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle2.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Own Damage</span></div>
											<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle2.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Theft</span></div>
											<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle2.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Accident To Driver</span></div>
											<div class="items-center" v-if="formData.options !== 4"><img class="mr-2" src="/img/Rectangle2.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;color: #9FB2BF">Passenger Liability</span></div>
                                            <div class="items-center" v-if="formData.options === 4"><img class="mr-2" src="/img/Select.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Third Party Liability</span></div>
                                            <div class="items-center" v-if="formData.options === 4"><img class="mr-2" src="/img/Select.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Own Damage</span></div>
                                            <div class="items-center" v-if="formData.options === 4"><img class="mr-2" src="/img/Select.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Theft</span></div>
                                            <div class="items-center" v-if="formData.options === 4"><img class="mr-2" src="/img/Select.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Accident To Driver</span></div>
                                            <div class="items-center" v-if="formData.options === 4"><img class="mr-2" src="/img/Select.png" width="12" height="12"><span style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;">Passenger Liability</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="xs:hidden col-span-4">
                                    <p class="text-md-scale font-semibold">Choose options</p>
                                    <div>
                                        <el-radio-group @change="onSelectScopeOfCoverOption" size="small" v-model="formData.options">
                                            <el-radio-button class="w-3/12" :label="1">Opt 1</el-radio-button>
                                            <el-radio-button class="w-3/12" :label="2">Opt 2</el-radio-button>
                                            <el-radio-button class="w-3/12" :label="3">Opt 3</el-radio-button>
                                            <el-radio-button class="w-3/12" :label="4">Opt 4</el-radio-button>
                                        </el-radio-group>
                                    </div>
                                    <div class="col-span-2 mt-3" v-for="(opt,index) in Options" :key="index">
                                        <div v-if="formData.options === opt.opt">
                                            <div class="flex items-center" v-for="scope in opt.scopeOfCovers">
                                                <img src="/img/Select.png" width="14" height="13"><p style="font-size: calc(12px + 1*((100vw - 320px)/1120)); !important;margin-left: 8px">{{scope.value}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-4 my-3">
                                    <div class="grid grid-cols-2 xs:grid-cols-4 flex items-center">
                                        <div class="col-span-4 xs:col-span-2 flex">
                                            <p class="font-semibold text-sm-scale">Option</p>
                                            <p class="text-sm-scale">(Additional options can be included)</p>
                                        </div>
                                        <div class="col-span-4 xs:col-span-2 mt-2">
                                            <el-checkbox-group class="px-0 pb-2 xs:flex" v-model="formData.optionals">
                                                <el-checkbox :disabled="formData.options === 3 || formData.options === 1 || formData.options === ''" :label="optional.flood" value="flood"></el-checkbox>
                                                <el-checkbox :disabled="formData.options === 3 || formData.options === 1 || formData.options === ''" :label="optional.srcc" value="srcc"></el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-4">
                                    <el-form-item size="small" label="Date of Effect" prop="period_from">

                                        <div class="grid grid-cols-1 xs:grid-cols-2">
                                            <div class="col-span-1 xs:col-span-1">
                                                <el-date-picker
                                                    class="w-full"
                                                    :editable="false"
                                                    v-model="formData.period_from"
                                                    v-on:change="onSelectPeriodFrom"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    clearable
                                                    format="dd/MMM/yyyy"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="DD/MMM/YYYY">
                                                </el-date-picker>
                                            </div>
                                            <div class="flex items-center ml-0 xs:ml-2 mt-2 xs:mt-0">
                                                <img class="mb-1" src="/img/Idea.png" width="15" alt="">
                                                <p class="text-xs-scale ml-1 leading-2">Make sure you understand your options.<el-button type="text" class="font-bold text-xs-scale text-navy underline underline-offset-4" v-on:click="onOpenScopeOfCoverDialog" >Click Here</el-button></p>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="col-span-4">
                                    <p class="font-semibold col-span-2 w-full mb-3 text-md-scale text-center">Upload your National ID or Company Information</p>
                                </div>
                                <div class="col-span-4">
                                   <UploadIdCard :formData="formData" @clear="onClearForm" @AssignFile="onAssignFileRaw"/>
                                </div>

                                <div class="col-span-4 mt-3">
                                    <p v-if="formData.type === 'Individual'" class="font-semibold w-full mb-3 text-md-scale col-span-2 text-center">PERSONAL INFORMATION</p>
                                    <p v-if="formData.type === 'Company'" class="font-semibold w-full mb-3 text-md-scale col-span-2 text-center">COMPANY INFORMATION</p>
                                    <div v-if="formData.type" class="step-card p-3 border-navy">
                                        <div class="text-right">
                                            <el-button @click="onDeleteClientInfo" class="text-navy p-0 bg-transparent border-0"
                                                       size="small"><div class="flex justify-center items-center">
                                                <i class="las la-trash-alt text-sm-scale"></i><span class="underline text-xs-scale">Clear</span>
                                            </div></el-button>
                                        </div>
                                        <div v-if="formData.type === 'Individual'" class="pt-4 grid grid-cols-1 xs:grid-cols-2 gap-x-3 xs:gap-x-5">
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Khmer Name">
                                                    <el-input
                                                        class="w-full"
                                                        v-model="formData.insured_name_kh"
                                                        placeholder="Full Name">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Gender">
                                                    <el-select placeholder="Gender"
                                                               class="w-full"
                                                               clearable
                                                               v-model="formData.gender">
                                                        <el-option
                                                            v-for="item in Genders"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="English Name" prop="insured_name">
                                                    <el-input
                                                        class="w-full"
                                                        v-model="formData.insured_name"
                                                        placeholder="English Name">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="National ID Number">
                                                    <el-input
                                                        class="w-full"
                                                        v-model="formData.id_card"
                                                        placeholder="National ID Number">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1 block">
                                                <el-form-item size="small" label="Phone Number" prop="phone">
                                                    <el-input @blur="onCheckPhoneNumber" placeholder="Phone Number" minlength="8" maxlength="9"
                                                              show-word-limit v-model="formData.phone">
                                                        <template slot="prepend"><span class="flex items-center"><img
                                                            src="/img/cambodia.png" height="18"
                                                            :width="'auto'">&nbsp;+855</span>
                                                        </template>
                                                    </el-input>
                                                </el-form-item>

                                                <el-form-item size="small" label="Email" prop="email">
                                                    <el-input
                                                        type="email"
                                                        class="w-full"
                                                        v-model="formData.email"
                                                        placeholder="Email">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Address" prop="full_address">
                                                    <el-input
                                                        :rows="3"
                                                        class="w-full"
                                                        v-model="formData.full_address"
                                                        type="textarea"
                                                        maxlength="150"
                                                        show-word-limit
                                                        placeholder="Address">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <div v-if="formData.type === 'Company'" class="pt-4 grid grid-cols-1 xs:grid-cols-2 gap-x-3 xs:gap-x-5">
                                            <div class="col-span-2 xs:col-span-1 block">
                                                <el-form-item size="small" label="Company Name" prop="insured_name">
                                                    <el-input
                                                        class="w-full"
                                                        v-model="formData.insured_name"
                                                        placeholder="English Name">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item size="small" label="Company Phone Number" prop="phone">
                                                    <el-input @blur="onCheckPhoneNumber" placeholder="Phone Number" minlength="8" maxlength="9"
                                                              show-word-limit v-model="formData.phone">
                                                        <template slot="prepend"><span class="flex items-center"><img
                                                            src="/img/cambodia.png" height="18"
                                                            :width="'auto'">&nbsp;+855</span>
                                                        </template>
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Company Address" prop="full_address">
                                                    <el-input
                                                        :rows="3"
                                                        class="w-full"
                                                        v-model="formData.full_address"
                                                        type="textarea"
                                                        maxlength="150"
                                                        show-word-limit>
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Company Email" prop="email">
                                                    <el-input
                                                        type="email"
                                                        class="w-full"
                                                        v-model="formData.email"
                                                        placeholder="Email">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                            <div class="col-span-2 xs:col-span-1">
                                                <el-form-item size="small" label="Company's Attach File">
                                                    <el-input
                                                        disabled
                                                        class="w-full"
                                                        v-model="formData.company_attach_file"
                                                        placeholder="Attach file">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>

                    <div v-if="step !== 2" class="w-full mt-3 block md:flex xs:justify-end xs:items-end">

                        <div class="text-right">
                            <el-button v-if="step !== 0" size="small" @click="previous" class="text-primary font-normal text-sm-scale px-5" style="border-color: var(--primaryColor)">Back</el-button>
                            <el-button v-if="step !== 2" size="small" @click="next" class="bg-primary font-normal text-sm-scale text-white px-5">Next</el-button>
<!--                            <el-button size="small" @click="onTest" class="bg-primary font-normal text-sm-scale text-white px-5">Test</el-button>-->
                        </div>
                    </div>
            </div>
        </div>

        <!--Confirm On Buy Product-->
        <el-dialog
            :visible.sync="ConfirmDialog"
            :close-on-press-escape="false"
            :append-to-body="false"
            class="dialog-wrapper"
            custom-class="dialog-agree"
            :show-close="false">
            <template slot="title">
                <div class="flex justify-end">
                    <el-button   @click="ConfirmDialog = false"  size="small" class="text-navy bg-secondary-light hover:bg-gray-100 p-1 rounded-full mt-2 mr-2" type="text"><i class="las la-times text-lg-scale"></i></el-button>
                </div>
            </template>
            <div class="text-center p-1">
                <div class="text-wrap px-5">
                    <p class="font-semibold text-md-scale xs:text-base">We would like to inform you that our vehicle insurance is designed exclusively for personal use and does not cover commercial purposes.</p>
                </div>
                <div class="items-center py-4">
                    <el-button v-on:click="onAgreeBuyNow" size="small" class="w-32 bg-primary font-medium text-sm-scale text-white">Agree</el-button>
                </div>
            </div>
        </el-dialog>


        <TermAndConditionPolicy :policy_type="formData.policy_type" @onAccept="onAcceptTermCondition" ref="dialogTermRef"/>
        <DialogPayment :formData="formData" ref="dialogPaymentRef"/>
        <DialogMessage ref="dialogMessageRef"/>
    </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Cookies from "js-cookie";
import axios from 'axios';
import {Inertia} from '@inertiajs/inertia'
import Login from '@/Pages/Auth/Login'
import elementUi from '@/Plugins/element-ui'
import Motorcycle from '@/Components/TermConditionPolicy/Motorcycle'
import DialogPayment from '@/Components/DialogPayment'
import DialogMessage from '@/Components/DialogMessage'
export default {
    layout: Layout,
    name: 'Motor',
    /*props: {
        auth: Object,
        quote: Object,
    },*/
    data(){
        return{
            step: 0,
            lastUploadTime: this.$moment().unix(),
            optional:{
                flood : 'Flood',
                srcc : 'Strikes, Riots and Civil Commotion Clause'
            },
            isAgreeBuyNow:false,
            File_Raw:'',
            spin:{
                payment : false,
                next : false,
                loading:false,
                activate:false,
            },
            formData:{
                valid_coupon:'',
                coupon_code:'',
                id_card:'',
                phone:'',
                email:'',
                gender:'',
				dob:'',
                insured_name:'',
                insured_name_kh:'',
                full_address:'',
                type:'',
                company_attach_file:'',
                files_raw:[],
                options:'',
                optionals:[],
                policy_type:'',
                policy_type_id:'',
                scope_of_cover:'',
                period:'',
                period_from:'',
                period_to:'',
                purpose_of_use:'Personal Use',
                total_premium:0,
                after_dis:0,
                old_total_premium:0,
                total_premium_f:0,
                total_premium_src:0,
                issued_by_en:'',
                issued_by_kh:'',
                issued_date:'',
				pob:'',
                client_id : '',

                payment_status:'',
                payment_option:'',
                dn_no:'',
                date_paid:'',
                paid_premium:0,
                quote_items:[],
                quote_id:'',
                premium_due:0,
                bank:'',
                bank_ref:'',
                method:'',
            },
            motors:[],
            Genders:[{label:'Male',value:'M'},{label: 'Female',value:'F'}],
            Options: [
                {
                    opt: 1,
                    scopeOfCovers: [
                        {
                            key: 'tpl',
                            value: 'Third Party Liability',
                        },
                    ],
                },
                {
                    opt: 2,
                    scopeOfCovers: [
                        {
                            key: 'tpl',
                            value: 'Third Party Liability',
                        },
                        {
                            key: 'od',
                            value: 'Own Damage',
                        },
                        {
                            key: 'theft',
                            value: 'Theft',
                        },
                    ],
                },
                {
                    opt:3,
                    scopeOfCovers: [
                        {
                            key: 'tpl',
                            value: 'Third Party Liability',
                        },
                        {
                            key: 'ad',
                            value: 'Accident to Driver',
                        },
                        {
                            key: 'pl',
                            value: 'Passenger Liability',
                        },
                    ],
                },
                {
                    opt:4,
                    scopeOfCovers: [
                        {
                            key: 'tpl',
                            value: 'Third Party Liability',
                        },
                        {
                            key: 'od',
                            value: 'Own Damage',
                        },
                        {
                            key: 'theft',
                            value: 'Theft',
                        },
                        {
                            key: 'ad',
                            value: 'Accident to Driver',
                        },
                        {
                            key: 'pl',
                            value: 'Passenger Liability',
                        },
                    ],
                }
            ],
            ConfirmDialog:false,
            isAccepted:false,
            pickerOptions: {disabledDate: this.handleDepDate,},
        }
    },
    components: {
        Motorcycle,
        UploadIdCard: () => import('@/Components/UploadIdCard'),
        UploadRegistrationCard: () => import('@/Components/UploadRegistrationCard'),
        TermAndConditionPolicy: () => import('@/Components/TermConditionPolicy/Motorcycle'),
        DialogPayment,
        DialogMessage,
    },
    computed: {
        rulesFormData(){
            return{
                policy_type: [{required: true, message: 'This field is required', trigger: 'change'}],
                insured_name: [{required: true, message: 'This field is required', trigger: 'blur'}],
                //email: [{required: true, message: 'This field is required', trigger: 'blur'}],
                email: [
                    {required: true, message: 'This field is required', trigger: 'blur'},
                    {type: 'email', message: 'Invalid Email', trigger: 'blur'}
                ],
                //gender: [{required: false, message: 'This field is required', trigger: 'change'}],
                phone: [{required: true, validator:this.onValidatePhoneNumber, trigger: 'blur'}],
                full_address: [{required: true, message: 'This field is required', trigger: 'blur'}],
                period_from: [{required: true, message: 'This field is required', trigger: 'change'}],
            }
        },
    },
    created() {

    },
    mounted() {
        if(!this.isAgreeBuyNow){
            this.ConfirmDialog = true;
        }
       /* if(this.$page.props.data && this.$page.props.data.is_paid){
            setTimeout(() => {
                this.$refs.dialogMessageRef.onOpenMessage("/img/upload-check.png", `<p class="text-success font-semibold text-md-scale">Recently, payment was successful!</p>
                                    <p class="text-navy text-sm-scale text-break mt-3">Thank you for choosing our services.<br>Kindly check your email : "<b class="font-weight-bold">${this.$page.props.data.email??''}</b>" for your insurance document.</p>`, '', true);
            }, 250);
        }*/
        this.onCheckPaidQuote();

    },
    methods:{
        onCalDiscountCoupon(){
            if(this.formData.policy_type !== 'Private Vehicle'){
                this.formData.valid_coupon = ''
                this.formData.coupon_code = ''
                //this.formData.options = 2
                //this.formData.total_premium = 140
                this.formData.old_total_premium = 0
                this.formData.after_dis = 0
                this.formData.total_premium_src = 0
                this.formData.total_premium_f = 0
                return
            }
            // if (this.formData.policy_type === 'Private Vehicle') {
            //     let value = (element.sum_insured * (0.35 / 100))
            //     if (value > 50) {
            //         //element.premium += value
            //         premium += value
            //     } else {
            //         //element.premium += 50
            //         premium += 50
            //     }
            // }
            // if (t.formData.optionals.includes('Flood')) {
            //     if (t.formData.policy_type === 'Private Vehicle') {
            //         if ((element.sum_insured * (0.5 / 100)) > 50) {
            //             //element.premium += element.sum_insured * (0.5 / 100)
            //             premium += element.sum_insured * (0.5 / 100)
            //         } else {
            //             //element.premium += 50
            //             premium += 50
            //         }
            //     }
            // }

            // if (this.formData.optionals.includes('Strikes, Riots and Civil Commotion Clause')) {
            //
            // }
            if (this.formData.policy_type === 'Private Vehicle' && this.formData.valid_coupon === 1) {
                this.formData.old_total_premium = this.formData.total_premium;
                let val = this.formData.total_premium_f + this.formData.total_premium_src;
                this.formData.total_premium -= val
                let dis = this.formData.total_premium * 0.3
                this.formData.after_dis = this.formData.total_premium - dis;
                this.formData.total_premium = this.formData.after_dis + val;
            }
        },
        onCheckCouponCode(){
            if (this.formData.valid_coupon === 1){
                this.formData.valid_coupon = '';
                this.formData.coupon_code = '';
                //this.formData.total_premium_f = 0;
                //this.formData.total_premium_src = 0;
                this.formData.coupon_code = '';
                this.formData.total_premium = this.formData.old_total_premium ;
                return
            }
            if(this.formData.coupon_code.length < 10)return
            // this.onCalDiscountCoupon();
            // return
            this.$inertia.post('/products/coupon/check', {
                code: this.formData.coupon_code,
                //type: 'Motor'
            },{
                preserveScroll: true,
                onStart: () => {
                    // Set loading to true when data fetching starts
                    this.spin.activate = true;
                },
                onSuccess: (data) => {
                    if (data.props.flash.data) {
                        console.log('valid coupon')
                        this.formData.valid_coupon = data.props.flash.data
                        //this.formData.options = 2
                        this.onCalDiscountCoupon();
                        this.onSaveDoc()
                    }
                },
                onError: () => { this.spin.activate = false;},
                onFinish: () => {this.spin.activate = false;},
            });
        },
        onCheckPaidQuote(){
            this.$inertia.post('/products/payway/check', {},{
                preserveScroll: true,
                onStart: () => {
                    // Set loading to true when data fetching starts
                    this.spin.loading = true;
                },
                onSuccess: (data) => {
                    if (data.props.flash.data && data.props.flash.data.is_paid) {
                        setTimeout(() => {
                            this.$refs.dialogMessageRef.onOpenMessage("/img/upload-check.png", `<p class="text-success font-semibold text-md-scale">Recently, payment was successful!</p>
                                    <p class="text-navy text-sm-scale text-break mt-3">Thank you for choosing our services.<br>Kindly check your email : "<b class="font-weight-bold">${data.props.flash.data.email ?? ''}</b>" for your insurance document.</p>`, '', true);
                        }, 300);
                    }
                },
                onError: () => { this.spin.loading = false;},
                onFinish: () => {this.spin.loading = false;},
            });
        },
        onAssignFileRaw(file){
            this.File_Raw = file;
        },
        onClearForm(){
            try {
                this.$nextTick(() => {
                    this.$refs.formDataForm.clearValidate();
                });
            }catch (e) {
                console.log(e);
            }
        },
        onAgreeBuyNow(){
            this.isAgreeBuyNow = true;
            this.ConfirmDialog = false;
        },
        onClickForm(){
            if(!this.isAgreeBuyNow){
                this.ConfirmDialog = true;
            }
        },
        onSelectProductType(e){
            e === 'Private Vehicle'? this.formData.policy_type_id = 16 : this.formData.policy_type_id = 17;
			this.isAccepted = false;
			this.$refs.dialogTermRef.isAccepted = '';
            this.motors = [];
        },
        onSelectScopeOfCoverOption(e) {
            if(!e) return;
            this.ScopeOfCovers = this.Options[e-1];
            if(this.formData.options === 1 || this.formData.options === 3){
                this.formData.optionals = [];
            }
            if(this.motors.length){
                if(this.formData.options === 1 || this.formData.options === 3){
                    // this.motors.forEach(element => {
                    //     element.sum_insured = 0;
                    //     element.premium = 0;
                    // });
                    if(this.formData.policy_type === 'Motocycle'){
                        // Filter the data array based on the condition
                        //this.motors[0].cylinder_size = 150;
                        //this.motors[0].cylinder_size = 170;
                        let filteredData = this.motors.filter(obj => parseInt(obj.cylinder_size) <= 150);

                        this.motors = filteredData
                    }
                }
            }
        },

        onCheckOptional(e){

        },

        onOpenScopeOfCoverDialog(){
            if(!this.formData.policy_type) return;
            this.$refs.dialogTermRef.onOpenDialog('soc',true);
        },

        onSelectPeriodFrom(e) {
            const period_to = this.$moment(e,'YYYY-MM-DD').add(365, 'day').subtract(1,'day').format('YYYY-MM-DD');
            this.formData.period_to = period_to;
            this.formData.period = 365;
            this.formData.issued_date = e;
        },

        handleDepDate(date) {
            const currentDate = this.$moment().startOf('day');
            const selectedDate = this.$moment(date).startOf('day');

            if (this.formData.period_to) {
                const arrivalDate = this.$moment(this.formData.period_to, 'YYYY-MM-DD').startOf('day');
                return selectedDate.isBefore(currentDate) || selectedDate.isAfter(arrivalDate);
            }
            return selectedDate.isBefore(currentDate);
        },

        onDeleteClientInfo(){
            this.formData.type = '';
            this.formData.insured_name = '';
            this.formData.insured_name_kh = '';
            this.formData.gender = '';
            this.formData.phone = '';
            this.formData.email = '';
            this.formData.full_address = '';
            this.formData.company_attach_file = '';
        },
        onCheckPhoneNumber(){
            try {
                let phone = parseFloat(this.formData.phone.replace(/\D/g, ''))
                this.formData.phone = phone
                if (isNaN(this.formData.phone)) {
                    this.formData.phone = 0
                }
            } catch (e) {
            }
        },
        onValidatePhoneNumber(rule,value,callback){
            if (value) {
                return callback();
            } else {
                return callback(new Error('This field is required'));
            }
        },
        onValidateEmail(rule, value, callback) {
            if (value) {
                if (value.includes('@')) {
                    return callback()
                } else {
                    return callback(new Error('invalid email'))
                }
            } else {
                return callback(new Error('This field is required'))
            }
        },

        onCheckEmail(){
            try {
                let email = this.formData.email.replace(/\s/g, '');
                this.formData.email=email;
            }catch (e) {
                console.log(e);
            }
        },

        onAcceptTermCondition(){
            this.step++;
            this.isAccepted = true;
            this.$refs.dialogTermRef.onOpenDialog('term',false);
        },

        onAssignIssuedBy(){
          this.formData.issued_by_en = this.formData.insured_name;
          this.formData.issued_by_kh = this.formData.insured_name_kh;
        },
        onScrollToStepForm(){
            const element = document.getElementById('step-form');
            if (element) {
                const offset = element.offsetTop - 70;
                window.scrollTo({ top: offset, behavior: 'smooth' });
            }
        },
        previous() {
            if(this.step !== 0){
                this.step--;
            }
            this.onScrollToStepForm();
        },

        next() {
            let self = this;
            if(self.step === 0){
				//console.log(self.formData);
                self.$refs['formDataForm'].validate(async (valid) => {
                    if (valid) {
                        self.onAssignIssuedBy();
                        //Check Upload Type
                        if(!self.formData.type){
                           // this.$refs.dialogMessageRef.onOpenMessage('/img/warning.png', `<p class="text-warning font-medium text-sm-scale">Warning<br>Missing Upload ID Card OR Company's Paten</p>`,'error',true);
                            this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Please upload ID card or company's patent</p>`,'error',true);
                            return false;
                        }
                        //Check Select Scope of Cover By Option
                        if (!self.formData.options) {
                         //   this.$refs.dialogMessageRef.onOpenMessage('/img/warning.png', `<p class="text-warning font-medium text-sm-scale">Warning<br>Missing Select Option</p>`,'error',true);
                            this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Please select the scope of cover option</p>`,'error',true);
                            return false;
                        }
                        // If not accepted, open the term dialog; otherwise, proceed to the next step
                        if (self.isAccepted) {
                            self.step++;
                        } else {
                            // If terms haven't been accepted, open the term dialog
                            self.openTermDialog();
                        }
                        self.onScrollToStepForm();
                        //self.onMergeFiles();
                    } else {
                      //  this.$refs.dialogMessageRef.onOpenMessage('/img/warning.png', `<p class="text-warning font-semibold text-sm-scale">Warning<br>Missing Required Field</p>`, 'warning', true);
                        this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Please fill in the required fields</p>`, 'error', true);
                        return false;
                    }
                })
            } else if (self.step === 1) {
                if(!self.motors.length){
                    if(self.formData.policy_type === 'Private Vehicle'){
                        this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Private vehicle information is missing</p>`, 'error', true);
                    }else {
                        this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Motocycle information is missing.</p>`, 'error', true);
                    }
                    return;
                }
                const valid = self.onCheckItems(self.motors);
                //self.formData.quote_items = self.motors;
                if(valid){
                    self.onCalculatePremium();
                    self.onMergeFiles();
                    self.step++;
                    self.onScrollToStepForm();
                    self.onSaveDoc()
                }
               // self.onScrollToStepForm();
            }else {
                self.step++;
                self.onScrollToStepForm();
            }
        },

        openTermDialog() {
            this.$refs.dialogTermRef.onOpenDialog('term', true);
        },

        onCheckItems(items){
            let valid = true;
            items.forEach((element, index) => {
                //check sum insured
                if (!element.sum_insured) {
                    if(this.formData.options === 2 || this.formData.options === 4){
                        //this.$refs.dialogMessageRef.onOpenMessage('/img/warning.png', `<p class="text-warning font-semibold text-sm-scale">Warning<br>Missing Input Sum Insured</p>`, 'warning', true);
                        let content = this.formData.policy_type === "Motocycle"?`<p class="text-danger font-medium text-md-scale">Please provide the motocycle price</p>`:`<p class="text-danger font-medium text-md-scale">Please provide the private vehicle price</p>`;
                        //let content = `<p class="text-danger font-semibold text-sm-scale">Please provide the ${formData.policy_type} Price</p>`;
                        this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', content, 'error', true);
                        return valid = false;
                    }
                }
                if (this.formData.options === 3 || this.formData.options === 4) {
                    if (!element.seat_no && this.formData.policy_type === 'Private Vehicle') {
                        // this.$refs.dialogMessageRef.onOpenMessage('/img/warning.png', `<p class="text-warning font-semibold text-sm-scale">Warning<br>Missing Input Seat No Of Private Vehicle</p>`, 'warning', true);
                        this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Please provide the number of seats for the private vehicle</p>`, 'error', true)
                        return valid = false
                    }
                }
            });
            return valid;
        },

        onCalculatePremium(){
            let t = this;
            //let premium = 0;
            let total_premium = 0;
            this.motors.forEach((element, index) => {
                let premium = 0;
                if (t.formData.options === 1) {
                    //TPL
                    if (t.formData.policy_type === 'Private Vehicle') {
                        if (element.cylinder_size > 0 && element.cylinder_size <= 2000) {
                            //element.premium += 85
                            premium += 85
                        } else if (element.cylinder_size >= 2001 && element.cylinder_size <= 3000) {
                            //element.premium += 90
                            premium += 90
                        } else if (element.cylinder_size > 3000) {
                            //element.premium += 100
                            premium += 100
                        }
                    } else {
                        if (element.cylinder_size > 0 && element.cylinder_size <= 90) {
                            //element.premium += 40
                            premium += 40
                        } else if (element.cylinder_size >= 91 && element.cylinder_size <= 125) {
                            //element.premium += 50
                            premium += 50
                        } else if (element.cylinder_size >= 126 && element.cylinder_size <= 150) {
                            //element.premium += 60
                            premium += 60
                        }
                    }
                } else if (t.formData.options === 2) {
                    //TPL+OD+Theft(Comprehensive)
                    if (t.formData.policy_type === 'Private Vehicle') {
                        if (element.sum_insured > 0 && element.sum_insured <= 50000) {
                            if (element.sum_insured * (1.5 / 100) > 150) {
                                //element.premium += element.sum_insured * (1.5 / 100)
                                premium += element.sum_insured * (1.5 / 100)
                            } else {
                                //element.premium += 150
                                premium += 150
                            }
                        }
                    } else {
                        if (element.sum_insured > 0 && element.sum_insured <= 3500) {
                            if (element.sum_insured * (8 / 100) > 70) {
                                //element.premium += element.sum_insured * (8 / 100)
                                premium += element.sum_insured * (8 / 100)
                            } else {
                                //element.premium += 70
                                premium += 70
                            }
                        }
                    }
                } else if (t.formData.options === 3) {
                    if (t.formData.policy_type === 'Private Vehicle') {
                        //TPL
                        if (element.cylinder_size > 0 && element.cylinder_size <= 2000) {
                            //element.premium += 85
                            premium += 85
                        } else if (element.cylinder_size >= 2001 && element.cylinder_size <= 3000) {
                            //element.premium += 90
                            premium += 90
                        } else if (element.cylinder_size > 3000) {
                            //element.premium += 100
                            premium += 100
                        }
                        //PL
                        //element.premium += (element.seat_no * 5)
                        premium += (element.seat_no * 5)
                        //AD
                        //element.premium += 10
                        premium += 10
                    } else {
                        //TPL
                        if (element.cylinder_size > 0 && element.cylinder_size <= 90) {
                            //element.premium += 40
                            premium += 40
                        } else if (element.cylinder_size >= 91 && element.cylinder_size <= 125) {
                            //element.premium += 50
                            premium += 50
                        } else if (element.cylinder_size >= 126 && element.cylinder_size <= 150) {
                            //element.premium += 60
                            premium += 60
                        }
                        //PL
                        //element.premium += 10
                        premium += 10
                        //AD
                        //element.premium += 10
                        premium += 10
                    }
                } else if (t.formData.options === 4) {
                    if (t.formData.policy_type === 'Private Vehicle') {
                        //TPL+OD+Theft
                        if (element.sum_insured > 0 && element.sum_insured <= 50000) {
                            if (element.sum_insured * (1.5 / 100) > 150) {
                                //element.premium += element.sum_insured * (1.5 / 100)
                                premium += element.sum_insured * (1.5 / 100)
                            } else {
                                //element.premium += 150
                                premium += 150
                            }
                        }
                        //PL
                        //element.premium += (element.seat_no * 5)
                        premium += (element.seat_no * 5)
                        //AD
                        //element.premium += 10
                        premium += 10
                    } else {
                        //TPL+OD+Theft
                        if (element.sum_insured > 0 && element.sum_insured <= 3500) {
                            if (element.sum_insured * (8 / 100) > 70) {
                                //element.premium += element.sum_insured * (8 / 100)
                                premium += element.sum_insured * (8 / 100)
                            } else {
                                //element.premium += 70
                                premium += 70
                            }
                        }
                        //PL
                        //element.premium += 10
                        premium += 10
                        //AD
                        //element.premium += 10
                        premium += 10
                    }
                }
                if (t.formData.optionals.includes('Flood')) {
                    let value = element.sum_insured * (0.5 / 100)
                    if (t.formData.policy_type === 'Private Vehicle') {
                        if (value > 50) {
                            //element.premium += element.sum_insured * (0.5 / 100)
                            premium += value
                            t.formData.total_premium_f = value
                        } else {
                            //element.premium += 50
                            premium += 50
                            t.formData.total_premium_f = 50
                        }
                    } else {
                        if (value > 25) {
                            //element.premium += element.sum_insured * (0.5 / 100)
                            premium += value
                        } else {
                            //element.premium += 25
                            premium += 25
                        }
                    }
                }

                if (t.formData.optionals.includes('Strikes, Riots and Civil Commotion Clause')) {
                    let value = element.sum_insured * (0.35 / 100)
                    if (t.formData.policy_type === 'Private Vehicle') {
                        if (value > 50) {
                            //element.premium += value
                            premium += value
                            t.formData.total_premium_src = value
                        } else {
                            //element.premium += 50
                            premium += 50
                            t.formData.total_premium_src = 50
                        }
                    } else {
                        if (value > 25) {
                            //element.premium += value
                            premium += value
                        } else {
                            //element.premium += 25
                            premium += 25
                        }
                    }
                }
                element.item_no = (index+1);
                element.premium = premium;
                total_premium += premium;
            });
            t.formData.total_premium = total_premium;
            t.onCalDiscountCoupon();
        },

        async onMergeFiles() {
			let t = this;
			const files = new FormData();
			let file_raw = await new Promise((resolve, reject) => {
				setTimeout(async () => {
					try {
						const result = await this.$image.onCompressImage(this.File_Raw, 0.5);
						resolve(result);
					} catch (error) {
						reject(error);
					}
				}, 500);
			});
			files.append('insured image', file_raw);
			t.formData.quote_items = this.motors;
			let filesRawItems = this.motors;
			filesRawItems.forEach((object, index) => {
				// console.log(object.file_raw);
				// t.compressAndConvertToJPEG(object.file_raw);
				// if (object.file_raw) {
				//     files.append(`Item ${index + 1}`, object.file_raw);
				// }
				if (object.file_raw) {
					files.append(`Item ${index + 1}`, object.file_raw);
				}
			})
			t.formData.files_raw = files;
		},

        compressAndConvertToJPEG(file) {
            //const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Set canvas dimensions to desired compressed size
                    canvas.width = 800;
                    canvas.height = 600;

                    // Draw image onto canvas with desired quality
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Convert canvas content to base64-encoded JPEG
                    const compressedImageData = canvas.toDataURL('image/jpeg', 0.6);

                    // Perform further actions with compressed image data
                };
                img.src = e.target.result;
                const base64String = e.target.result;
                const blob = this.base64ToBlob(base64String, 'image/jpeg');
                // Create a URL for the blob object
                this.convertedRawData = URL.createObjectURL(blob);
            };

            reader.readAsDataURL(file);
        },
        base64ToBlob(base64String, mimeType) {
            const byteCharacters = atob(base64String.split(',')[1]);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: mimeType });
        },


        async onTest(){
            let motors = [{
                beneficiary_name: 'Phnom Penh 2AT-8244',
                owner_name: 'Neth',
                address: 'Bourei Muoy Roy Khnang Tuek Thla Saensokh Phnom Penh',
                plate_no: 'Phnom Penh 2AT-8244',
                axles_no: 2,
                brand: 'LEXUS GX470',
                chassis_no: 'NIL',
                color: 'WHITE',
                cylinder_no: 8,
                cylinder_size: 4700,
                engine_no: '2UZ0813079',
                engine_power: '235',
                frame_no: 'JTJBT20X840034232',
                premium: 50000,
                seat_no: 5,
                sum_insured: 3000,
                type: 'Family',
                year_made: 2004,
            },
                /*{
                address: 'Bourei Muoy Roy Khnang Tuek Thla Saensokh Phnom Penh',
                owner_name: 'Chimean',
                axles_no: '2',
                brand: 'LEXUS GX470',
                chassis_no: 'NIL',
                color: 'WHITE',
                cylinder_no: '8',
                cylinder_size: '4700',
                engine_no: '2UZ0813079',
                engine_power: '235',
                frame_no: 'JTJBT20X840034232',
                beneficiary_name: 'LY TEKHENG',
                plate_no: 'Phnom Penh 2AT-8244',
                premium: 60000,
                seat_no: 5,
                sum_insured: 4000,
                type: 'Family',
                year_made: 2004,
            }*/
            ];
            this.formData = {
                'insured_name': 'ban channara',
                'insured_name_kh': 'ban channara',
                'issued_by_en': 'ban channara',
                'issued_by_kh': 'ban channara',
                'email': 'banchanara7@gmail.com',
                'gender': 'Male',
                'phone': 987654987,
                'full_address': 'Takeo Province',
                'id_card': 123456789,
                'dob': '',
                'pob': 'Kompong speu',
                'type': 'Individual',
                //'type': 'Company',
                'files_raw': [],
                'passport_no': '123456789',
                'options': 4,
                'optionals': ['Flood','Strikes, Riots and Civil Commotion Clause'],
                //'policy_type': 'Motocycle',
                'policy_type': 'Private Vehicle',
                //'policy_type_id': 17,
                'policy_type_id': 16,
                'period': 365,
                'issued_date': '2023-02-05',
                'period_from': '2024-05-09',
                'period_to': '2024-08-09',
                'purpose_of_use': 'Personal Use',
                'status': 0,
                'scope_of_cover' : '',
                'total_premium': 2000,
                'payment_option': 'khqr',

                'quote_items':motors,
                'tran_id':23,
                'invoice_no':'PPI/DN/EQ9876',
                'paymentMethod':'KhQR',
                'payment_status':1,
                'amount':2000,
                'dn_no':'DN/PPI/E0001',
                company_attach_file:'',
                client_id : '',
                date_paid:'',
                paid_premium:0,
                quote_id:'',
                premium_due:0,
                bank:'',
                bank_ref:'',
                method:'',
            }
            this.isAgreeBuyNow = true;
            this.motors = motors;
            this.formData.motors = this.motors;
            this.step = 1;
        },


        async onSaveDoc() {
            try {
                this.spin.next = true;
                //  await this.onUploadFiles(this.formData.files_raw, 'PVPPIEQ-0216', true);
                //  return;
                //this.$refs.dialogMessageRef.onOpenMessage("/img/loading.gif", `<p class="text-navy font-medium text-md-scale">Requesting KHQR...</p>`,'loading',true);
                //let motors = this.motors;
                this.formData.quote_items = this.motors.map(item => {
                    // delete item.image;
                    // delete item.file_raw;
                    // return item;
                    const { file_raw, ...itemWithoutKeys } = item;
                    return {
                        ...itemWithoutKeys,
                    };
                });
                await new Promise( (resolve, reject) => {
                    this.$inertia.form({
                        'policy_type_id': this.formData.policy_type_id,
                        'policy_type': this.formData.policy_type,
                        'insured_name': this.formData.insured_name,
                        'insured_name_kh': this.formData.insured_name_kh,
                        'issued_by_en': this.formData.issued_by_en,
                        'issued_by_kh': this.formData.issued_by_kh,
                        'gender': this.formData.gender,
                        'phone': this.formData.phone,
                        'full_address': this.formData.full_address,
                        'dob': this.formData.dob?this.formData.dob:'',
                        'type': this.formData.type,
                        'period': this.formData.period,
                        'period_from': this.formData.period_from,
                        'period_to': this.formData.period_to,
                        'issued_date': this.formData.issued_date,
                        'status': 0,
                        'purpose_of_use': 'Personal Use',
                        'scope_of_cover': this.formData.options,
                        //'total_premium': '0.01',
                        'total_premium': this.formData.total_premium,
                        'quote_items': this.formData.quote_items,
                        'email': this.formData.email,
                        'id_card': this.formData.id_card,
                        'pob': this.formData.pob,
                        'optionals': this.formData.optionals.toString(),
                    }).post('/products/quote', {
                        headers: {"Content-Type" : "application/json"},
                        preserveScroll: true,
                        onSuccess: async (data) => {
                            if (data.props.flash.error) {
                                reject(new Error ('Request failed'))
                            } else {
                                // const status = data.props.flash.data
                                // if(status && status.is_paid){
                                //     setTimeout(() => {
                                //         this.$refs.dialogMessageRef.onOpenMessage("/img/upload-check.png", `<p class="text-success font-semibold text-md-scale">Recently, payment was successful!</p>
                                //     <p class="text-navy text-sm-scale text-break mt-3">Thank you for choosing our services.<br>Kindly check your email : "<b class="font-weight-bold">${status.email??''}</b>" for your insurance document.</p>`, '', true);
                                //     }, 250);
                                //     this.$refs.dialogPaymentRef.onClearForm();
                                //     return;
                                // }
                                //console.log(data.props.flash.data);
                                //await this.onUploadFiles(this.formData.files_raw);
                               // await this.onUploadFiles(this.formData.files_raw, data.props.flash.data, data.props.flash.data.is_update);
                                //this.formData.quote_no = data.props.flash.data.quote_no;
                                //await this.$refs.dialogPaymentRef.onOpenPayment();
                                //this.$refs.dialogMessageRef.onOpenMessage('/img/loading.gif', `<p class="text-navy font-medium text-md-scale">Loading...<br></p>`, 'loading', false);
                                //this.spin.payment = false;
                                resolve(data)
                            }
                        },
                        onError: (error) => {
                            reject(new Error ('Request failed'))
                        },
                    })
                })
                this.spin.next = false;
            } catch (error) {
                this.spin.next = false;
                setTimeout(() => {
                    this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Failed to request.</p>`,'',true)
                }, 250)
                window.location.reload();
                throw error;
            }
        },
        onOpenPaymentMethod(){
            this.spin.payment = true;
            this.$refs.dialogPaymentRef.onOpenPayment();
        },
        async onUploadFiles(files){
            return await new Promise((resolve, reject) => {
                this.$inertia.post(`/drive/upload`, files, {
                    headers: {
                        "Content-Type" : "multipart/form-data"
                    },
                    preserveScroll: true,
                    onSuccess: async (res) => {
                        resolve('Files has been successfully uploaded')
                    },
                    onError: (e) =>{
                        reject(e)
                    },
                });
            })
        },

    }
}
</script>

<style scoped>

div>>> .el-radio__inner {
	border: 1px solid #264D67 !important;
}
div >>> .el-table thead {
    color: var(--navy);
    /*font-size: calc(12px + 1 * ((100vw - 320px) / 1120));*/
    font-weight: 500;
    background-color: #F6F6F6;
}

.popover-content {
    padding: 5px 20px;
}

div >>> .el-table td {
        height: 40px;
}

div>>>.el-textarea__inner {
    padding: 23px 15px !important;
}

div >>> .el-table__header-wrapper {
    border-radius: 7px 7px 0 0;
}

div >>> .el-table tr, div >>> .el-table th.el-table__cell {
    background-color: transparent;
    border-bottom: 0;
    padding: 6px 0;
}
div>>> .el-table th.el-table__cell {
    font-size: calc(12px + 2 * ((100vw - 320px) / 1120));
}
div>>> .el-form-item__label {
    font-size: calc(13px + 1 * ((100vw - 320px) / 1120));
    font-weight: 300;
}
a{
    color: #264D67;
    font-size: calc(10px + 2 * ((100vw - 320px) / 1120));
    font-weight: bold;
}
div >>> .el-table thead {
    color: var(--navy);
    /*font-size: calc(12px + 1 * ((100vw - 320px) / 1120));*/
    font-weight: 500;
    background-color: #F6F6F6;
}
div>>> .el-form-item__label {
    font-weight: 600;
}
div>>> .step-card-motor {
    height: auto;
    border: 0.5px solid #9FB2BF;
    border-radius: 12px;
}
div>>> .el-radio-button__inner, .el-radio-group {
    width: 100% !important;
}
div >>> .el-input-group__append, div >>> .el-input-group__prepend {
    padding: 0 10px;
    font-weight: 500;
    font-size: calc(12px + 2 * ((100vw - 320px) / 1120)) !important;
    color: var(--navy);
    background-color: transparent;
    border-color: var(--navy);
}
/*div>>> .el-select-dropdown {*/
/*    padding: 0 12px;*/
/*    line-height: 50px !important;*/
/*    height: 500px !important;*/
/*    font-weight: 400;*/
/*    font-size: calc(12px + 1 * ((100vw - 320px) / 1120));*/
/*    color: var(--navy);*/
/*}*/

div>>> .el-input-number .el-input__inner{
    text-align: left;
}
div>>> .el-radio-button--small .el-radio-button__inner
{
    font-weight: bold;
    color: #264D67;
}

p{
    color: #264D67;
}
div>>> .el-step__description.is-process img {
    color: var(--primaryColor);
    font-weight: bold;
}
.el-form--label-top .el-form-item__label {
    float: left;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
}

div>>> el-button:hover{
    background:none;
}
div >>> .avatar-uploader {
    border: 1.5pt dotted var(--navy);
    width: auto;
    border-radius: 6px;
    cursor: pointer;
    align-items: center !important;
    position: relative;
    overflow: hidden;
    background-color: #F6F6F6 !important;
}

div >>> .avatar-uploader:hover {
    border-color: #C0C4CC !important;
}

div >>> .avatar-uploader-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

div >>> .avatar {
    width: auto;
    height: 140px;
    border-radius: 0;
    display: inline-block;
    background-color: transparent;
    background-size: cover;
    background-position: center center;
}
div>>> .el-dialog__header{
    padding: 0px ;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5px;
    padding-left: 5px;
}
div>>> .el-dialog__body{
    padding-top: 5px;
    padding-bottom: 15px;
    padding-right: 10px;
    padding-left: 10px;
}

div>>> .el-checkbox__inner {
    border: 1px solid #264D67;
}

div>>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #264D67 !important;
    background: #264D67 !important;
}
div>>> .el-radio-button--mini .el-radio-button__inner {
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 0;
    width: 520px !important;
}
div>>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #FFF !important;
    background-color: #264D67;
    border-color: #264D67;
    box-shadow: 0px 0 0 0 #264D67;
}
div>>> .el-radio-button__orig-radio:hover + .el-radio-button__inner {
    color: #264D67;
}

div >>>.dialog-scan,div >>>.dialog-edit,div>>>.dialog-preview,div>>>.dialog-payment,div>>>.dialog-agree{
    width: 90%;
}
div>>>.dialog-agree .el-dialog__header,div>>>.dialog-preview .el-dialog__header{
    padding: 0;
}
div>>>.dialog-agree .el-dialog__body,div>>>.dialog-edit .el-dialog__body, div>>>.dialog-plans .el-dialog__body,div>>>.dialog-preview .el-dialog__body{
    /* padding: 0 15px 15px 15px;*/
    padding: 0;
}
div>>> dialog-soc{
    width: 95% !important;
}
div >>> .el-table thead {
    color: var(--navy);
    /*font-size: calc(12px + 1 * ((100vw - 320px) / 1120));*/
    font-weight: 500;
    background-color: #F6F6F6;

}

div >>> .el-table__header-wrapper {
    border-radius: 7px 7px 0 0;
}

div >>> .el-table tr, div >>> .el-table th.el-table__cell {
    background-color: transparent;
    border-bottom: 0;
    padding: 6px 0;
}
@media (min-width: 320px) {
    div>>> .dialog-preview{
        width: 90% !important;
    }
    div>>> .dialog-agree{
        width: 97% !important;
        padding-left: 0px;
        padding-right: 0px;
    }
 /*   div>>> .el-step__description{
        margin-top: 0;
        font-size: 15px;
    }*/
}
@media (min-width: 375px) {
    div>>> .dialog-agree{
        width: 92% !important;
        padding-left: 0px;
        padding-right: 0px;
    }
}
@media (min-width: 576px) {
    div>>> .dialog-preview{
        width: 80% !important;
    }
}
@media (min-width: 768px) {
    .plans p{
        padding-bottom: 12px;
    }
    .plans p:last-child{
        padding-bottom: 3px;
    }

    .plans p:first-child {
        padding: 0 10px;
        margin: 0;
        position: relative;
        z-index: 100;
        background-color: #FFFFFF;
    }

    .plans:last-child p:not(:first-child){
        padding-left: 15px;
    }
    .plans-wrapper {
        display: flex;
        position: relative;
    }
    .plans-wrapper::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 49.50%;
        border-left: 1px solid var(--navy);
        z-index: 0;

    }
    div>>>.dialog-edit{
        width: 55% !important;
    }
    div>>>.dialog-scan{
        width: 55% !important;
    }
    div>>>.dialog-aba{
        width: 50%;
    }
    div>>>.dialog-plans{
        width: 60% !important;
    }
    /* div>>>.dialog-edit .el-dialog__body{
       padding: 0 25px !important;
     }*/
    div>>>.dialog-preview .el-dialog__body{
        padding: 0  25px !important;
    }
    div>>>.dialog-preview{
        width: 80% !important;
    }
    div>>>.dialog-payment{
        width: 55% !important;
    }
    div>>>.dialog-agree{
        width:70% !important;
    }
}
@media (min-width: 992px) {
    /*  div>>> .el-dialog__headerbtn {
          top: 20px;
          right: 27px;
          font-size: 24px;
          outline: 0;
      }*/
    div>>>.dialog-aba{
        width: 42%;
    }
    div>>>.dialog-preview{
        width: 80% !important;
    }

    div>>>.dialog-plans{
        width: 80% !important;
    }
    div>>>.dialog-edit{
        width: 42% !important;
    }
    div>>>.dialog-payment{
        width: 40% !important;
    }
    div >>>.dialog-scan .el-dialog__header{
        padding: 20px 25px 10px 25px;
    }
    div>>>.dialog-plans .el-dialog__header{
        padding: 0;
    }
    /* div>>>.dialog-scan .el-dialog__body,div>>>.dialog-edit .el-dialog__body,div>>>.dialog-plans .el-dialog__body{
         !*padding: 0 25px 25px 25px;*!
         padding: 0;
     }*/

}
@media (min-width: 1024px) {
    div>>>.dialog-agree{
        width: 30% !important;
    }
}
@media (min-width: 1200px) {
    div>>>.dialog-scan{
        width: 40% !important;
    }
    div>>>.dialog-aba{
        width: 30%;
    }
    div>>>.dialog-edit{
        width: 30% !important;
    }
    div>>>.dialog-payment{
        width: 30% !important;
    }
    div>>>.dialog-preview{
        width: 70% !important;
    }
    div>>>.dialog-agree{
        width: 35% !important;
    }
}
@media (min-width: 1440px){
    div>>>.dialog-aba{
        width: 25%;
    }
    div>>>.dialog-preview{
        width: 60% !important;
    }
    div>>>.dialog-agree{
        width: 32% !important;
    }
}
@media (min-width: 1920px){
    div>>>.dialog-aba{
        width: 20%;

    }
    div>>>.dialog-scan{
        width: 25% !important;
    }
    div>>>.dialog-edit{
        width: 20% !important;
    }
    div>>>.dialog-preview, div>>>.dialog-plans{
        width: 45% !important;
    }
    div>>>.dialog-agree{
        width: 25% !important;
    }
}
@media (min-width: 2500px){
    div>>>.dialog-aba{
        width: 15%;

    }
    div>>>.dialog-edit{
        width: 17% !important;
    }
    div>>>.dialog-preview, div>>>.dialog-plans{
        width: 38% !important;
    }
    div>>> .dialog-agree{
        width: 20% !important;
    }

}
</style>
